module.exports = __webpack_public_path__ + "img/Romania.000179a1.png";